import React from 'react';
// import PropTypes from 'prop-types';

import { useTheme } from '../../ThemeContext';

import {
  Wrapper,
  Box,
  Panel,
  Header,
  Title,
  Category,
  Deco,
  Table,
  Row,
  Cell,
  Button,
  ButtonIcon,
} from './AiTraining.style';

const AiTraining = () => {
  const theme = useTheme();

  return (
    <Wrapper>
      <Box>
        <Panel theme={theme.aiTraining.panel}>
          <Header>
            <Title theme={theme.aiTraining.title}>
              <Category theme={theme.aiTraining.category}>
                Neural Networks
              </Category>{' '}
              being trained <Deco theme={theme.aiTraining.deco}>3</Deco>
            </Title>
          </Header>
          <Table>
            <Row theme={theme.aiTraining.row.head} head>
              <Cell theme={theme.aiTraining.cell.head} head>
                NN Name
              </Cell>
              <Cell theme={theme.aiTraining.cell.head} head>
                Data source
              </Cell>
              <Cell theme={theme.aiTraining.cell.head} head>
                NN classes
              </Cell>
              <Cell theme={theme.aiTraining.cell.head} head>
                NN outputs
              </Cell>
              <Cell theme={theme.aiTraining.cell.head} head>
                Start date
              </Cell>
              <Cell theme={theme.aiTraining.cell.head} head>
                Estimated training duration
              </Cell>
              <Cell theme={theme.aiTraining.cell.head} head></Cell>
            </Row>
            <Row theme={theme.aiTraining.row.default}>
              <Cell theme={theme.aiTraining.cell.default}>NN Cars</Cell>
              <Cell theme={theme.aiTraining.cell.default}>Cars</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>
                2019-09-17 15:00:00
              </Cell>
              <Cell theme={theme.aiTraining.cell.default}>05:00:00</Cell>
              <Cell theme={theme.aiTraining.cell.default} right>
                <Button theme={theme.button.danger} tiny disabled>
                  <ButtonIcon className={'material-icons'}>
                    delete_outline
                  </ButtonIcon>
                </Button>
                <Button theme={theme.button.default} tiny disabled>
                  <ButtonIcon className={'material-icons'}>info</ButtonIcon>
                </Button>
              </Cell>
            </Row>
            <Row theme={theme.aiTraining.row.default}>
              <Cell theme={theme.aiTraining.cell.default}>NN Animals</Cell>
              <Cell theme={theme.aiTraining.cell.default}>Animals</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>
                2019-09-16 14:55:00
              </Cell>
              <Cell theme={theme.aiTraining.cell.default}>04:00:00</Cell>
              <Cell theme={theme.aiTraining.cell.default} right>
                <Button theme={theme.button.danger} tiny disabled>
                  <ButtonIcon className={'material-icons'}>
                    delete_outline
                  </ButtonIcon>
                </Button>
                <Button theme={theme.button.default} tiny disabled>
                  <ButtonIcon className={'material-icons'}>info</ButtonIcon>
                </Button>
              </Cell>
            </Row>
            <Row theme={theme.aiTraining.row.default}>
              <Cell theme={theme.aiTraining.cell.default}>NN Clothes</Cell>
              <Cell theme={theme.aiTraining.cell.default}>Clothes</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>
                2019-09-15 19:22:00
              </Cell>
              <Cell theme={theme.aiTraining.cell.default}>03:00:00</Cell>
              <Cell theme={theme.aiTraining.cell.default} right>
                <Button theme={theme.button.danger} tiny disabled>
                  <ButtonIcon className={'material-icons'}>
                    delete_outline
                  </ButtonIcon>
                </Button>
                <Button theme={theme.button.default} tiny disabled>
                  <ButtonIcon className={'material-icons'}>info</ButtonIcon>
                </Button>
              </Cell>
            </Row>
          </Table>
        </Panel>
        <Panel theme={theme.aiTraining.panel}>
          <Header>
            <Title theme={theme.aiTraining.title}>
              <Category theme={theme.aiTraining.category}>
                Neural Networks
              </Category>{' '}
              saved <Deco theme={theme.aiTraining.deco}>4</Deco>
            </Title>
          </Header>
          <Table>
            <Row theme={theme.aiTraining.row.head} head>
              <Cell theme={theme.aiTraining.cell.head} head>
                NN Name
              </Cell>
              <Cell theme={theme.aiTraining.cell.head} head>
                Data source
              </Cell>
              <Cell theme={theme.aiTraining.cell.head} head>
                NN classes
              </Cell>
              <Cell theme={theme.aiTraining.cell.head} head>
                NN outputs
              </Cell>
              <Cell theme={theme.aiTraining.cell.head} head>
                Start date
              </Cell>
              <Cell theme={theme.aiTraining.cell.head} head></Cell>
              <Cell theme={theme.aiTraining.cell.head} head></Cell>
            </Row>
            <Row theme={theme.aiTraining.row.default}>
              <Cell theme={theme.aiTraining.cell.default}>NN Cars</Cell>
              <Cell theme={theme.aiTraining.cell.default}>Cars</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>
                2019-09-17 15:00:00
              </Cell>
              <Cell theme={theme.aiTraining.cell.default}></Cell>
              <Cell theme={theme.aiTraining.cell.default} right>
                <Button theme={theme.button.danger} tiny disabled>
                  <ButtonIcon className={'material-icons'}>
                    delete_outline
                  </ButtonIcon>
                </Button>
                <Button theme={theme.button.default} tiny disabled>
                  <ButtonIcon className={'material-icons'}>info</ButtonIcon>
                </Button>
              </Cell>
            </Row>
            <Row theme={theme.aiTraining.row.default}>
              <Cell theme={theme.aiTraining.cell.default}>NN Animals</Cell>
              <Cell theme={theme.aiTraining.cell.default}>Animals</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>
                2019-09-16 14:55:00
              </Cell>
              <Cell theme={theme.aiTraining.cell.default}></Cell>
              <Cell theme={theme.aiTraining.cell.default} right>
                <Button theme={theme.button.danger} tiny disabled>
                  <ButtonIcon className={'material-icons'}>
                    delete_outline
                  </ButtonIcon>
                </Button>
                <Button theme={theme.button.default} tiny disabled>
                  <ButtonIcon className={'material-icons'}>info</ButtonIcon>
                </Button>
              </Cell>
            </Row>
            <Row theme={theme.aiTraining.row.default}>
              <Cell theme={theme.aiTraining.cell.default}>NN Clothes</Cell>
              <Cell theme={theme.aiTraining.cell.default}>Clothes</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>
                2019-09-15 19:22:00
              </Cell>
              <Cell theme={theme.aiTraining.cell.default}></Cell>
              <Cell theme={theme.aiTraining.cell.default} right>
                <Button theme={theme.button.danger} tiny disabled>
                  <ButtonIcon className={'material-icons'}>
                    delete_outline
                  </ButtonIcon>
                </Button>
                <Button theme={theme.button.default} tiny disabled>
                  <ButtonIcon className={'material-icons'}>info</ButtonIcon>
                </Button>
              </Cell>
            </Row>
          </Table>
        </Panel>
        <Panel theme={theme.aiTraining.panel}>
          <Header>
            <Title theme={theme.aiTraining.title}>
              <Category theme={theme.aiTraining.category}>
                Neural Networks
              </Category>{' '}
              trained <Deco theme={theme.aiTraining.deco}>360</Deco>
            </Title>
          </Header>
          <Table>
            <Row theme={theme.aiTraining.row.head} head>
              <Cell theme={theme.aiTraining.cell.head} head>
                NN Name
              </Cell>
              <Cell theme={theme.aiTraining.cell.head} head>
                Data source
              </Cell>
              <Cell theme={theme.aiTraining.cell.head} head>
                NN classes
              </Cell>
              <Cell theme={theme.aiTraining.cell.head} head>
                NN outputs
              </Cell>
              <Cell theme={theme.aiTraining.cell.head} head>
                Start date
              </Cell>
              <Cell theme={theme.aiTraining.cell.head} head>
                End date
              </Cell>
              <Cell theme={theme.aiTraining.cell.head} head></Cell>
            </Row>
            <Row theme={theme.aiTraining.row.default}>
              <Cell theme={theme.aiTraining.cell.default}>NN Cars</Cell>
              <Cell theme={theme.aiTraining.cell.default}>Cars</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>
                2019-09-17 15:00:00
              </Cell>
              <Cell theme={theme.aiTraining.cell.default}>
                2019-09-16 14:55:00
              </Cell>
              <Cell theme={theme.aiTraining.cell.default} right>
                <Button theme={theme.button.normal} tiny disabled>
                  <ButtonIcon className={'material-icons'}>save_alt</ButtonIcon>
                </Button>
                <Button theme={theme.button.danger} tiny disabled>
                  <ButtonIcon className={'material-icons'}>
                    delete_outline
                  </ButtonIcon>
                </Button>
                <Button theme={theme.button.default} tiny disabled>
                  <ButtonIcon className={'material-icons'}>info</ButtonIcon>
                </Button>
              </Cell>
            </Row>
            <Row theme={theme.aiTraining.row.default}>
              <Cell theme={theme.aiTraining.cell.default}>NN Animals</Cell>
              <Cell theme={theme.aiTraining.cell.default}>Animals</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>
                2019-09-16 14:55:00
              </Cell>
              <Cell theme={theme.aiTraining.cell.default}>
                2019-09-16 14:55:00
              </Cell>
              <Cell theme={theme.aiTraining.cell.default} right>
                <Button theme={theme.button.normal} tiny disabled>
                  <ButtonIcon className={'material-icons'}>save_alt</ButtonIcon>
                </Button>
                <Button theme={theme.button.danger} tiny disabled>
                  <ButtonIcon className={'material-icons'}>
                    delete_outline
                  </ButtonIcon>
                </Button>
                <Button theme={theme.button.default} tiny disabled>
                  <ButtonIcon className={'material-icons'}>info</ButtonIcon>
                </Button>
              </Cell>
            </Row>
            <Row theme={theme.aiTraining.row.default}>
              <Cell theme={theme.aiTraining.cell.default}>NN Clothes</Cell>
              <Cell theme={theme.aiTraining.cell.default}>Clothes</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>5</Cell>
              <Cell theme={theme.aiTraining.cell.default}>
                2019-09-15 19:22:00
              </Cell>
              <Cell theme={theme.aiTraining.cell.default}>
                2019-09-16 14:55:00
              </Cell>
              <Cell theme={theme.aiTraining.cell.default} right>
                <Button theme={theme.button.normal} tiny disabled>
                  <ButtonIcon className={'material-icons'}>save_alt</ButtonIcon>
                </Button>
                <Button theme={theme.button.danger} tiny disabled>
                  <ButtonIcon className={'material-icons'}>
                    delete_outline
                  </ButtonIcon>
                </Button>
                <Button theme={theme.button.default} tiny disabled>
                  <ButtonIcon className={'material-icons'}>info</ButtonIcon>
                </Button>
              </Cell>
            </Row>
          </Table>
        </Panel>
      </Box>
    </Wrapper>
  );
};

AiTraining.propTypes = {};

export default AiTraining;
